module.exports = "<div class=\"noConnection\">\n  <img src=\"assets/img/no-connection.svg\" alt=\"no-connection\">\n  <h2>No internet connection</h2>\n  <p>Check your connection or try again</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/apps/asna/front-end/public_html/src/app/components/no-connection/no-connection.component.html
// module id = ../../../../../src/app/components/no-connection/no-connection.component.html
// module chunks = main